import styled from '@emotion/styled/macro';

export const EstimateForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.colors.primary};
  padding-bottom: ${(props) =>
    props.paddingBottom ? `${props.paddingBottom}px` : '0'};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 38px;
`;

export const UserName = styled('div')`
  flex: 1;
  paddingleft: 8px;
`;

export const InputReview = styled('div')`
  padding: 0 12px;
`;

export const Input = styled('input', {
  shouldForwardProp: (prop) => !['isInvalid'].includes(prop),
})`
  display: flex;
  width: 100px;
  min-height: 38px;

  // background-color: #fafbfc;
  background-color: ${({ theme }) => theme.input.background};
  border: 0;
  padding: 8px 12px;

  -webkit-appearance: none;
  border: none;
  border-radius: 3px;
  box-shadow: ${({ isInvalid, theme }) =>
    isInvalid ? theme.input.boxShadowError : theme.input.boxShadow};
  box-sizing: border-box;
  line-height: 20px;
  outline: none;
  transition-duration: 85ms;
  transition-property: background-color, border-color, box-shadow;
  transition-timing-function: ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.input.boxShadowHovered};
  }

  &:focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.input.boxShadowFocused};
  }
`;
